<template>
  <div>
    <div v-title data-title="安丘专技教育-重置密码"></div>
    <phone-login-layout>
      <login-form-component type="re-register"></login-form-component>
    </phone-login-layout>
  </div>

</template>

<script>
  import LoginFormComponent from '@/page/login/components/loginFormComponent'
  import PhoneLoginLayout from '@/page/login/components/phoneLoginLayout'
  export default {
    name: "phoneReRegister",
    components: {
      LoginFormComponent,
      PhoneLoginLayout
    }
  }
</script>

<style scoped>

</style>
